import React from 'react';
import type { AlertProps } from 'antd';

import StyledAlertBanner from './styled.tsx';

export interface BaseAlertBannerProps extends AlertProps {
    isDefaultType?: boolean;
}

export const BaseAlertBanner: React.FC<BaseAlertBannerProps> = ({
    showIcon = true,
    type = 'success',
    isDefaultType = false,
    ...props
}) => <StyledAlertBanner className={isDefaultType ? 'default' : ''} {...props} type={type} showIcon={showIcon} />;
